module.exports = __webpack_public_path__ + "static/wpack/extracted/news-mit58447fc9e6d2a4fee6e805077ba4e728.png";